// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-csG","largestCol":"styles_largestCol__1egM8","smallestCol":"styles_smallestCol__11-zU"};